<template>
    <div class="orderPage">
        <div class="title">确认订单信息</div>
        <div class="order-content">
            <h1 class="titles">订单信息</h1>
            <div class="exam-list">
                <div class="exam">
                    <img :src="goodDetail.coverImage" alt="">
                    <div class="list">
                        <h2 class="name">{{goodDetail.name}}</h2>
                        <!-- <p class="time">有效期：{{time}}</p> -->
                        <p class="label">商品金额：<span class="price">¥{{goodDetail.salePrice}}</span><span v-if="goodDetail.basePrice" class="throungh-price">¥{{goodDetail.basePrice}}</span></p>
                    </div>
                </div>
            </div>
            <div class="type" v-if="false">
                <h2>支付方式</h2>
                <div class="payment">
                    <img class="wximg" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-pc/gongxin/wxzf.png" alt="">
                    <span class="label">微信支付</span>
                    <div class="rightB"></div>
                    <img class="xzimg" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-pc/gongxin/dg.png" alt="">
                </div>
            </div>

            <div class="pay">
                <div class="right">
                  <span class="paidIn">实付金额：<span class="money">¥{{goodDetail.salePrice}}</span></span>
                  <span class="btn" @click="preOrder" v-show="goodDetail.salePrice">立即支付</span>
                </div>
            </div>
        </div>
        <el-dialog
            class="tip-dialog"
            :visible.sync="paymentdialogVisible"
            width="400px"
            :before-close="closeCode"
            :close-on-click-modal='false'>
            <div class="payment" v-if="type == 'payment'">
                <img class="close" @click="closeCode" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-pc/gongxin/gb.png" alt="">
                <p class="payment-title">
                    <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-pc/gongxin/weixin.png" alt="">
                    <span class="label">微信支付</span>
                    <span class="icon">¥<span class="num">{{goodDetail.salePrice}}</span></span>
                </p>
                <div class="scan">
                    <div id="qrCode" ref="qrCodeDiv"></div>
                    <div class="left"></div>
                    <div class="right"></div>
                </div>
                <p class="tip">使用微信扫描二维码进行支付</p>
            </div>
            <div class="success" v-if="false">
                <img :src="type == 'success'? img1 : img2 " class="icon-img" alt="">
                <p class="titles">{{type == 'success'? '支付成功' : '支付失败'}}</p>
                <p class="text">{{type == 'success'? '支付成功！你可以点击下方按钮，进行学习。' : '支付失败，请你检查微信账户余额、网络状态，确认后重新支付。'}}</p>
                <el-button class="btn" @click="jumpStudy">{{type == 'success'? '立即学习' : '重新支付'}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: 'orderPage',
  show: true,
    data() {
        return {
            goodDetail: {},
            orderDetail: {},
            paymentdialogVisible: false,
            type: '',
            img1: 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-pc/gongxin/zfcg.png',
            img2: 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-pc/gongxin/zfsb.png',
            Countdown: null,
            qrcodeState: '',
        };
    },
    filters: {
      dataFormat(msg) {
        if (msg) {
            const m = (msg||'').split(' ')[0].split('-');
            const s = m.join('.');
            return s;
        }
      }
    },
    mounted() {
        this.getOrderDetail()
    },
    computed:{
//有效期
      time(){
        if(this.goodDetail.validityType==1){
          return "永久有效"
        }else if(this.goodDetail.validityType==2){
          let snewTime = ""; let enewTime = "";
          if(this.goodDetail.startTime){
              let sarr = this.goodDetail.startTime.split(' ');
              let stimeArr = sarr[0].split('-');
              stimeArr[0] = stimeArr[0]+'年';
              stimeArr[1] = stimeArr[1]+'月';
              stimeArr[2] = stimeArr[2]+'日';
              snewTime = stimeArr.join('');
          }
          if(this.goodDetail.endTime){
            let earr = this.goodDetail.endTime.split(' ');
            let etimeArr = earr[0].split('-');
            etimeArr[0] = etimeArr[0]+'年';
            etimeArr[1] = etimeArr[1]+'月';
            etimeArr[2] = etimeArr[2]+'日';
            enewTime = etimeArr.join('');
          }
          return snewTime+"-"+enewTime
        }else if(this.goodDetail.validityType==3){
          if(this.goodDetail.startTime&&this.goodDetail.endTime){
            let sarr = this.goodDetail.startTime.split(' ');
            let stimeArr = sarr[0].split('-');
            stimeArr[0] = stimeArr[0]+'年';
            stimeArr[1] = stimeArr[1]+'月';
            stimeArr[2] = stimeArr[2]+'日';
            let snewTime = stimeArr.join('');
            let earr = this.goodDetail.endTime.split(' ');
            let etimeArr = earr[0].split('-');
            etimeArr[0] = etimeArr[0]+'年';
            etimeArr[1] = etimeArr[1]+'月';
            etimeArr[2] = etimeArr[2]+'日';
            let enewTime = etimeArr.join('');
            return snewTime+"-"+enewTime
          }else{
            let earr = this.goodDetail.endTime.split(' ');
            let etimeArr = earr[0].split('-');
            etimeArr[0] = etimeArr[0]+'年';
            etimeArr[1] = etimeArr[1]+'月';
            etimeArr[2] = etimeArr[2]+'日';
            let enewTime = etimeArr.join('');
            return "至"+enewTime
          }
        }else{
          return "报名后"+this.goodDetail.days+"天内有效"
        }
      }
    },
    created() {
        this.paymentdialogVisible = JSON.parse(sessionStorage.getItem("dialogState")) || this.paymentdialogVisible;
        this.type = sessionStorage.getItem("typeState") || this.type;
        this.qrcodeState = sessionStorage.getItem("qrcodeState")?JSON.parse(sessionStorage.getItem("qrcodeState")) : ''
        if (this.qrcodeState) {
            this.qrcodeimg(this.qrcodeState);
        }
    },
    beforeDestroy() {
        clearInterval(this.intervalId)

    },
    methods: {
        jumpStudy () {
            if (this.type == 'success') {
                // sessionStorage.setItem('dy-mode', '1');
                // 清楚缓存弹框状态
                sessionStorage.removeItem("dialogState")
                // 清楚缓存支付状态
                sessionStorage.removeItem("typeState");
                // 清楚缓存二维码
                sessionStorage.removeItem("qrcodeState");
                this.$router.replace(`/course/catalog?id=${this.goodDetail.referId}&dymode=1`)
            } else {
                this.preOrder()
            }
        },

        // 查询订单详情
        async getOrderDetail() {
            let res = await this.$api.order.getOrderByNo(this.$route.query.orderNo)
            this.orderDetail = res.data;
            this.goodDetail = res.data.goodsDto;
            this.getOrderStatus()
            this.intervalId = setInterval(() => {
                this.getOrderStatus()
            }, 3000)
        },
        //  查询订单状态
        async getOrderStatus() {
            let res = await this.$api.order.getOrderStatus(this.$route.query.orderNo)
            if(res.data.orderStatus !== 0 ) {
                //
                clearInterval(this.intervalId)
                if(res.data.url) {
                    window.open(res.data.url, '_self')
                } else {
                    this.$router.replace({
                        path: '/learn/list'
                    })
                }
            }

        },

       // 现在立即支付跳转到统一收银台
        preOrder() {
            this.$api.order.prePayOrde({
                data:{
                    orderId:this.orderDetail.id,
                    orderNo:this.orderDetail.orderNo,
                    totalMoney:this.goodDetail.salePrice,
                    payInfoDesc:this.goodDetail.name,
                    scene: 3
                }
            }).then(res=>{
                if (res.success) {
                    this.$api.order.launchPay({
                        data:{
                            orderNo:this.orderDetail.orderNo,
                            scene: 3
                        }
                    }).then(res=>{
                        if (res.data) {
                            // pay.testing1.wdeduc.com
                            // pay.testing3.wdeduc.com
                            // pay.fat.wdeduc.com
                            // pay.uat.wdeduc.com
                            // pay.wdeduc.com

                            let hostname = window.location.hostname
                            let port = window.location.port;
                            let isIP=/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
                            // let arr =  hostname.split('.');
                            // let isDTYProEnv = !hostname.split('.').splice(3).join('.'); //线上的定制化主题
                            //let API = arr[0].includes('hrss') ?  `https://pay.${arr.splice(1).join('.')}` : `https://pay.${isDTYProEnv ? arr.splice(1).join('.') : arr.splice(2).join('.')}`

                            let API  = ''
                            let locationHref = window.location.href
                            if (locationHref.includes('testing')) {
                                // API = 'https://pay.testing3.wdeduc.com'
                                API = 'https://fwyz-test.wdeduc.com'
                            } else if (locationHref.includes('fat')) {
                                API = 'https://pay.fat.wdeduc.com'
                            } else if (locationHref.includes('uat')) {
                                API = 'https://pay.uat.wdeduc.com'
                            } else  {
                                API = 'https://pay.wdeduc.com'
                            }

                            if(isIP.test(hostname) || hostname.includes('dev') || !!port){
                                API = 'https://localhost:8081';
                            }
                            const backUrl = encodeURIComponent(window.location.protocol+'//'+window.location.hostname)
                            window.open(API  + "/jjPcPay?orderNo=" + this.orderDetail.orderNo + '&token=' + localStorage.getItem('token') + '&organ=' + localStorage.getItem('organ') + '&actor=' + localStorage.getItem('actor') + '&branch=' + localStorage.getItem('branch') + '&referId=' + this.goodDetail.referId + '&theme=gongxin' + '&backUrl=' + backUrl);
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }).catch(err=>{
                        console.log('err', err)
                    })
                }
            })
        },
        // 生成二维码
        qrcodeimg (data) {
            this.paymentdialogVisible = true;
            // 缓存弹框状态
            sessionStorage.setItem("dialogState", this.paymentdialogVisible);
            this.type = 'payment';
            // 缓存支付状态
            sessionStorage.setItem("typeState", this.type);
            setTimeout(() => {
                new QRCode(this.$refs.qrCodeDiv, {
                    text: data.codeUrl,
                    width: 150,
                    height: 150,
                    colorDark: '#333333', // 二维码颜色
                    colorLight: '#ffffff', // 二维码背景色
                    correctLevel: QRCode.CorrectLevel.H // 容错率L/M/H
                }, 100)
            })
            this.findAndSetPayStatus(data.payNo)
        },
        findAndSetPayStatus(data) {
            this.Countdown = null
            const payNos = data || this.qrcodeState.payNo
            this.Countdown = setInterval(() => {
                this.$api.order.findAndSetPayStatus(payNos).then(res=>{
                    if (res.data==true) {
                        clearInterval(this.Countdown)
                        this.type = 'success'
                        sessionStorage.setItem("typeState", this.type);
                        sessionStorage.removeItem("qrcodeState");
                    } else if (res.code != 0) {
                        clearInterval(this.Countdown)
                        this.type = 'fail'
                        sessionStorage.setItem("typeState", this.type);
                        sessionStorage.removeItem("qrcodeState");
                    }
                })
            }, 3000)
        },
        // 关闭弹框,清除已经生成的二维码
        closeCode () {
            this.paymentdialogVisible = false
            sessionStorage.setItem("dialogState", this.paymentdialogVisible);
            this.$refs.qrCodeDiv.innerHTML = ''
            clearInterval(this.Countdown)
            sessionStorage.removeItem("dialogState")
            sessionStorage.removeItem("typeState");
            sessionStorage.removeItem("qrcodeState");
        }
    }
};
</script>
<style lang="less" scoped>
.PurchaseAgreementBody{
    
    .PurchaseAgreementText{
        font-size: 16px;
        color: #666666;
        line-height: 28px;
        overflow-y: scroll;
        max-height: 404px;
    }
}
.purchaseAgreementDialog {
  /deep/.el-dialog__title{
    font-size: 24px;
    font-weight: 500;
    color: #1B2257;
    line-height: 34px;
  }
  /deep/.el-dialog--center .el-dialog__body{
    padding-top: 10px;
  } 
  /deep/.el-button{
    padding: 0;
    width: 240px;
    height: 40px;
    background: #316FFF;
    span{
      font-size: 16px;
      color: #FFFFFF;
      line-height: 22px;
    }
  } 
}

.orderPage {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    .title {
        height: 80px;
        line-height: 80px;
        font-size: 24px;
        font-weight: 600;
        color: #222222;
    }
    .order-content {
        width: 1200px;
        // height: 550px;
        background: #FFFFFF;
        .titles {
            height: 54px;
            line-height: 54px;
            font-size: 16px;
            color: #333333;
            padding-left: 24px;
            border-bottom: 1px solid #F5F5F5;
        }
        .exam-list {
            padding: 24px;
            border-bottom: 1px solid #F5F5F5;
            .exam {
                width: 1152px;
                height: 198px;
                background: #F8F9FA;
                position: relative;
                img {
                    position: absolute;
                    left: 24px;
                    top: 24px;
                    width: 200px;
                    height: 150px;
                }
                .list {
                    margin-left: 240px;
                    padding-top: 28px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    height: 150px;
                    box-sizing: border-box;
                    .name {
                        font-size: 20px;
                        font-weight: 500;
                        color: #333333;
                        margin-bottom: 16px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    .time {
                        font-size: 16px;
                        color: #666666;
                        margin-bottom: 49px;
                    }
                    .label {
                        font-size: 18px;
                        color: #999999;
                        .price {
                            font-size: 22px;
                            font-family: Avenir-Heavy, Avenir;
                            font-weight: 800;
                            color: #e82424;
                        }
                        .throungh-price{
                            text-decoration: line-through;
                        }
                    }
                }
            }
        }
        .type {
            height: 140px;
            border-bottom: 1px solid #F5F5F5;
            padding: 16px 0 0 24px;
            h2 {
                font-size: 16px;
                color: #333333;
                margin-bottom: 16px;
            }
            .payment {
                width: 200px;
                height: 28px;
                background: #F8F9FA;
                border-radius: 8px;
                border: 1px solid #316FFF;
                padding: 26px 0;
                text-align: center;
                position: relative;
                overflow: hidden;
                .wximg {
                    margin-right: 10px;
                }
                .label {
                    font-size: 16px;
                    color: #333333;
                    vertical-align: super;
                }
                .rightB {
                    width:0;
                    height:0;
                    border-right:24px solid #316FFF;
                    border-top:24px solid transparent;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                }
                .xzimg {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                }
            }
        }
        .pay {
            height: 42px;
            text-align: right;
            padding: 24px;
            display: flex;
            justify-content: space-between;
            .left{
              display: flex;
              align-items: center;
              img{
                margin-right: 4px;
                width: 14px;
              }
              p{
                font-size: 16px;
                color: #666666;
                line-height: 22px;
                span{
                  color: #316FFF;
                  cursor:pointer;
                }
              }
            }
            .paidIn {
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #E82424;
                margin-right: 18px;
                .money {
                    font-size: 30px;
                    font-family: Avenir-Heavy, Avenir;
                    font-weight: 800;
                    color: #E82424;
                }
            }
            .btn {
                display: inline-block;
                width: 104px;
                height: 40px;
                background: #FF8131;
                border-radius: 4px;
                font-size: 16px;
                color: #FFFFFF;
                vertical-align: bottom;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
            }
        }
    }
    .tip-dialog {
        .payment {
            position:relative;
            .close {
                position:absolute;
                top:-26px;
                right:4px;
                cursor:pointer;
            }
            .payment-title {
                margin-top: 10px;
                text-align: center;
                height: 34px;
                line-height: 34px;
                margin-bottom: 22px;
                img {
                    width:32px;
                    margin-right:4px;
                    vertical-align: sub;
                }
                .label {
                    font-size: 24px;
                    font-weight: 600;
                    color: #1B2257;
                    margin-right:4px;
                }
                .icon {
                    font-size: 24px;
                    font-family: Avenir Heavy;
                    font-weight: 600;
                    color: #E82424;
                    margin-right:4px;
                    .num {
                        font-size: 32px;
                        font-family: Avenir Heavy;
                        font-weight: 600;
                        color: #E82424;
                        margin-right:4px;
                    }
                }
            }
            .scan {
                border: 1px solid #F6F6F6;
                width: 160px;
                height: 160px;
                margin: 0 auto;
                position: relative;
                margin-bottom: 16px;
                #qrCode {
                    /deep/img {
                        margin: 0 auto;
                        margin-top: 5px;
                    }
                }
                .left, .right {
                    position:absolute;
                    width:14px;
                    height:14px;
                }
                .left {
                    top:-3px;
                    left:-3px;
                    border-top: 2px solid #316FFF;
                    border-left: 2px solid #316FFF;
                }
                .right {
                    bottom: -3px;
                    right: -3px;
                    border-bottom: 2px solid #316FFF;
                    border-right: 2px solid #316FFF;
                }
            }
            .tip {
                font-size: 16px;
                color: #666666;
            }
        }
        .success {
            text-align: center;
            img {
                width:160px;
                height:160px;
                margin-top: -20px;
                margin-bottom: 0;
            }
            .titles {
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #1B2257;
                margin-bottom: 10px;
            }
            .text {
                font-size: 16px;
                color: #666666;
                padding: 0 10px;
                margin-bottom: 30px;
            }
            .btn {
                width: 240px;
                height: 40px;
                background: #316FFF;
                cursor pointer
                /deep/span {
                    font-size: 16px;
                    color: #FFFFFF;
                }
            }
        }
    }
}
</style>
